import { Link } from "react-router-dom";
import SectionHeader from "../components/ui/SectionHeader";
import { realizations, services } from "../data/siteData";

function HomePage() {
  return (
    <>
      <section className="surface">
        <div className="shell grid gap-10 py-14 sm:py-20 lg:grid-cols-[1fr_.9fr] lg:items-center lg:py-24">
          <div>
            <p className="eyebrow">ELTT elektroinstalace</p>
            <h1 className="mt-4 max-w-3xl text-5xl font-extrabold tracking-tight text-white sm:text-6xl">
              Spolehliva elektro prace bez zbytecneho chaosu.
            </h1>
            <p className="mt-6 max-w-xl text-lg leading-8 text-slate-300">
              Elektroinstalace, rekonstrukce, revize a servis pro domy, byty a mensi firmy.
              Jasna domluva, ciste predani a dokumenty pohromade.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link to="/kontakt" className="btn-primary">
                Poslat poptavku
              </Link>
              <Link to="/sluzby" className="btn-secondary">
                Zobrazit sluzby
              </Link>
            </div>
          </div>

          <div className="overflow-hidden rounded-lg border border-cyan-300/15 bg-[#06111b]">
            <img
              src="https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1200&q=85"
              alt="Elektroinstalace v rozvadeci"
              className="h-72 w-full object-cover sm:h-96 lg:h-[440px]"
            />
          </div>
        </div>
      </section>

      <section className="page-section surface-soft">
        <div className="shell">
          <SectionHeader kicker="Co delame" title="Hlavni sluzby">
            Prehled nejcastejsich elektro praci pro rodinne domy, byty a mensi provozy.
          </SectionHeader>
          <div className="mt-8 grid gap-5 md:grid-cols-2">
            {services.map((service) => (
              <article key={service.title} className="card p-6">
                <h2 className="text-xl font-bold text-white">{service.title}</h2>
                <p className="mt-3 text-sm leading-6 text-slate-300">{service.description}</p>
                <p className="mt-5 text-sm font-semibold text-cyan-300">{service.price}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="surface py-12 sm:py-16">
        <div className="shell grid gap-8 lg:grid-cols-[.85fr_1fr] lg:items-center">
          <SectionHeader kicker="Postup" title="Jednoduchy proces">
            Nejdriv kratka domluva, potom prohlidka nebo naceneni, realizace a predani dokumentu.
          </SectionHeader>
          <div className="grid gap-4 sm:grid-cols-3">
            {["Poptavka", "Nabidka", "Realizace"].map((step, index) => (
              <div key={step} className="card p-5">
                <div className="text-sm font-semibold text-cyan-300">0{index + 1}</div>
                <div className="mt-2 font-bold text-white">{step}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="page-section surface-soft">
        <div className="shell">
          <div className="flex flex-col justify-between gap-5 sm:flex-row sm:items-end">
            <SectionHeader kicker="Realizace" title="Ukazky prace" />
            <Link to="/realizace" className="btn-secondary">
              Vsechny realizace
            </Link>
          </div>
          <div className="mt-8 grid gap-5 md:grid-cols-3">
            {realizations.map((item) => (
              <article key={item.title} className="card overflow-hidden">
                <img src={item.image} alt={item.title} className="h-48 w-full object-cover" />
                <div className="p-5">
                  <h2 className="font-bold text-white">{item.title}</h2>
                  <p className="mt-1 text-sm text-slate-400">{item.place}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default HomePage;
